import { Modal } from "antd";
import AddVacancyForm from "../Vacancy/AddVacancyForm";

const UpdateVacancyModal = ({ isOpen, onClose, vacancyId, vacancy }) => {
  return (
    <Modal
      title="Update Vacancy"
      open={isOpen}
      onCancel={onClose}
      width={1000}
      footer={null}
      destroyOnHidden
    >
      <AddVacancyForm
        vacancyId={vacancyId}
        onClose={onClose}
        vacancy={vacancy}
        action="Update Vacancy"
      />
    </Modal>
  );
};

export default UpdateVacancyModal;
